export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: '',
      },
      {
        title: 'Choose your payment plan',
        description:
          'Different payment plans may be shown depending on the purchase amount and credit score.',
      },
      {
        title: 'Complete your checkout',
        description:
          'The amount will be charged based on the payment plan you chose.',
      },
    ],
  },
  de: {
    title: 'Jetzt shoppen. Sicher und flexibel bezahlen. Mit Klarna.',
    subTitle: 'Entscheide selbst, wie du bezahlst.',
    timelineHeader: 'So funktioniert\'s',
    timelineItems: [
      {
        title: 'Wähle Klarna im Checkout',
        description: '',
      },
      {
        title: 'Entscheide dich für einen Zahlungsplan',
        description:
          'Je nach Kaufbetrag und Kreditwürdigkeit werden dir möglicherweise andere Zahlungspläne angezeigt.',
      },
      {
        title: 'Schließe deine Einkauf ab',
        description:
          'Wie du bezahlst, hängt von deinem Zahlungsplan ab',
      },
    ],
  },
}
